/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-interaction-background: var(--nve-sys-interaction-background-200);
  --nve-sys-interaction-field-background: var(--nve-sys-interaction-background-200);
  --color: var(--nve-sys-text-muted-color);
  --padding: var(--nve-ref-size-200) var(--nve-ref-size-500);
  --font-weight: var(--nve-ref-font-weight-semibold);
  --font-size: var(--nve-ref-font-size-100);
  --height: var(--nve-ref-size-1000);
  --min-width: var(--nve-ref-size-1000);
  --justify-content: start;
  --border-left: 0;
  --border-right: 0;
  transition: box-shadow 300ms ease-in-out;
}

[internal-host] {
  background: var(--background);
  color: var(--color);
  padding: var(--padding);
  height: var(--height);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  min-width: var(--min-width);
  border-left: var(--border-left);
  border-right: var(--border-right);
  justify-content: var(--justify-content);
  display: flex;
  align-items: center;
  outline-offset: -5px;
  white-space: nowrap;
}

:host([width='max-content']) {
  --padding: var(--nve-ref-size-300);
}

::slotted(nve-sort-button),
::slotted(nve-icon-button) {
  margin-inline-start: auto;
}

@media (hover: hover) {
  ::slotted(nve-sort-button) {
    opacity: 0;
  }

  ::slotted(nve-sort-button[sort='ascending']),
  ::slotted(nve-sort-button[sort='descending']),
  :host(:focus-within) ::slotted(nve-sort-button),
  :host(:hover) ::slotted(nve-sort-button) {
    opacity: 1;
  }
}
